<template>
  <div id="app">
    <router-view/>
  </div>
</template>

<script>
export default {
  name: 'App'
}
</script>

<style>
* {
  box-sizing: border-box;
}

html,
body {
  margin: 0;
  padding: 0;
  width: 100%;
  overflow-x: hidden;
}

#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
  margin: 0;
  min-height: 100%;
  width: 100%;
}

/* 表格横向滚动容器 */
.table-scroll-wrapper {
  width: 100%;
  overflow-x: auto;
  -webkit-overflow-scrolling: touch;
}

.table-scroll-wrapper .el-table {
  min-width: 640px;
}

/* 筛选工具栏 */
.filter-toolbar {
  display: flex;
  flex-wrap: wrap;
  align-items: flex-end;
  gap: 12px;
  margin-bottom: 16px;
}

.filter-toolbar .filter-search {
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
  flex: 1 1 240px;
  min-width: 0;
  align-items: center;
}

.filter-toolbar .filter-search .el-input {
  flex: 1 1 180px;
  min-width: 0;
}

.filter-toolbar .filter-search .el-button {
  flex: 0 0 auto;
}

.filter-toolbar .filter-actions {
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
  flex: 0 0 auto;
}

/* 分页 */
.pagination-container {
  margin-top: 16px;
  display: flex;
  justify-content: center;
  overflow-x: auto;
  -webkit-overflow-scrolling: touch;
}

.pagination-container .el-pagination {
  white-space: nowrap;
}

/* 汇总卡片行 */
.summary-row {
  margin-bottom: 20px;
}

@media (max-width: 768px) {
  .el-dialog {
    width: 92% !important;
    margin-top: 8vh !important;
  }

  .el-dialog__body {
    padding: 16px;
  }

  .el-form-item__label {
    float: none;
    display: block;
    text-align: left;
    line-height: 1.4;
    padding-bottom: 4px;
  }

  .el-form-item__content {
    margin-left: 0 !important;
  }

  .filter-toolbar {
    flex-direction: column;
    align-items: stretch;
  }

  .filter-toolbar .filter-search,
  .filter-toolbar .filter-actions {
    width: 100%;
    flex: none;
  }

  .filter-toolbar .filter-search {
    flex-wrap: nowrap;
    align-items: center;
  }

  .filter-toolbar .filter-search .el-input {
    flex: 1;
  }

  .filter-toolbar .filter-search .el-button {
    flex: 0 0 auto;
    align-self: center;
  }

  .filter-toolbar .filter-actions .el-button {
    flex: 1;
    margin-left: 0 !important;
  }

  .pagination-container {
    justify-content: flex-start;
  }

  .el-card__body {
    padding: 12px;
  }

  .el-button + .el-button {
    margin-left: 8px;
  }
}
</style>
